module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transactionreconciliation"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar', {
    attrs: {
      "fatherMethod": _vm.initialize
    }
  }), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("分账交易列表")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("交易搜索")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.searchlist.sku_title),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "sku_title", $$v)
      },
      expression: "searchlist.sku_title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入订单号"
    },
    model: {
      value: (_vm.searchlist.trade_id),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "trade_id", $$v)
      },
      expression: "searchlist.trade_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("收件人姓名")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入收件人姓名"
    },
    model: {
      value: (_vm.searchlist.receiver_name),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "receiver_name", $$v)
      },
      expression: "searchlist.receiver_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("收件人手机号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入收件人手机号"
    },
    model: {
      value: (_vm.searchlist.receiver_phone),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "receiver_phone", $$v)
      },
      expression: "searchlist.receiver_phone"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("时间范围")]), _vm._v(" "), _c('a-range-picker', {
    attrs: {
      "defaultValue": (!_vm.searchlist.start_time && !_vm.searchlist.end_time) ? null : [_vm.moment(_vm.searchlist.start_time, _vm.dateFormat), _vm.moment(_vm.searchlist.end_time, _vm.dateFormat)]
    },
    on: {
      "change": _vm.onChangeTime
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchbtn
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-container"
  }, [_c('a-tabs', {
    attrs: {
      "defaultActiveKey": _vm.liststatus,
      "activeKey": _vm.liststatus,
      "type": "card",
      "tabBarGutter": 5
    },
    on: {
      "change": _vm.tabChange
    }
  }, [_c('a-tab-pane', {
    key: "isclear",
    attrs: {
      "tab": "已结算"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 7
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("状态")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("订单号：" + _vm._s(item.trade_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e()], 1), _vm._v(" "), _vm._l((item.TC_Orders), function(order) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))])])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100)), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t一级代理价:￥" + _vm._s(order.first_agency_price / 100)), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t二级代理价:￥" + _vm._s(order.second_agency_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        },
        attrs: {
          "span": 6
        }
      }, [_vm._v(_vm._s(_vm.status[order.order_status]))])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 15
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address))])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), ((item.first_agency_id || item.second_agency_id) && !(item.profitsharing_info || item.profitsharing_fail_info)) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("该订单含有代理分账：")]), _vm._v(" "), _c('a-button', {
      on: {
        "click": function($event) {
          return _vm.profitsharingquery(item)
        }
      }
    }, [_vm._v("查询")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info || item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "start",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t分账状态提交记录：已提交\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t一级代理分账信息：" + _vm._s(_vm.get_first_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t二级代理分账信息：" + _vm._s(_vm.get_second_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v(_vm._s(item.profitsharing_fail_info))])])], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t实际分账信息：" + _vm._s(item.profitsharing_info.status) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((item.profitsharing_info.receivers), function(receivers, receiversindex) {
      return _c('a-col', {
        key: receiversindex,
        attrs: {
          "span": 8
        }
      }, [(receivers.type == 'MERCHANT_ID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(receivers.description) + ",金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (receivers.type == 'PERSONAL_OPENID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t账户:" + _vm._s(receivers.user_id) + ",实际分账金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
    })], 2) : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: "notclaer",
    attrs: {
      "tab": "未结算"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.tradelist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 7
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("买家")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "font-weight": "600",
        "border": "#e8e8e8 solid 1px",
        "height": "30px",
        "line-height": "30px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 8
      }
    }, [_vm._v("订单号：" + _vm._s(item.trade_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("运费：￥" + _vm._s(item.delivery_fee / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v("订单实付：￥" + _vm._s(item.receipt_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_vm._v("创建时间：" + _vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), (item.trade_platform == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：微信")]) : _vm._e(), _vm._v(" "), (item.trade_platform == 2) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("订单提交平台：Excel")]) : _vm._e()], 1), _vm._v(" "), _vm._l((item.TC_Orders), function(order) {
      return _c('a-row', {
        key: order.id,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "padding": "10px"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticStyle: {
          "width": "70px",
          "height": "70px",
          "background-color": "#f3f3f5"
        }
      }, [_c('img', {
        attrs: {
          "src": order.sku_cover,
          "width": "70",
          "height": "70"
        }
      })])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 5
        }
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(order.sku_title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.sku_properties))])])]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [(item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('s', [_vm._v("￥" + _vm._s(order.original_price / 100))]) : _vm._e(), _vm._v(" "), (item.UIC_User.member_level !== 1 && order.original_price && order.original_price > order.sku_price) ? _c('br') : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t￥" + _vm._s(order.sku_price / 100)), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t一级代理价:￥" + _vm._s(order.first_agency_price / 100)), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t二级代理价:￥" + _vm._s(order.second_agency_price / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(order.amount))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        },
        attrs: {
          "span": 2
        }
      }, [_c('a-popover', {
        attrs: {
          "trigger": "hover"
        }
      }, [_c('template', {
        slot: "content"
      }, [_c('p', [_vm._v("ID:" + _vm._s(item.UIC_User.id))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "position": "relative"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "inline-block",
          "width": "100%",
          "word-break": "break-all",
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(item.UIC_User.nick_name))]), _vm._v(" "), _c('a-tag', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "color": "orange"
        }
      }, [_vm._v(_vm._s(item.UIC_User.member_level == 1 ? '会员' : item.UIC_User.member_level == 2 ? 'VIP会员' : item.UIC_User.member_level == 3 ? '钻石会员' : '皇冠会员'))])], 1)], 2)], 1), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 4
        }
      }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t总价：￥ " + _vm._s(order.sku_price * order.amount / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t应付：￥ " + _vm._s(order.receipt_price / 100) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t优惠券满减：￥ -" + _vm._s(order.coupon_derate_fee * order.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('a-col', {
        attrs: {
          "span": 1
        }
      }), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center",
          "color": "#0099FF",
          "font-weight": "700"
        },
        attrs: {
          "span": 5
        }
      }, [_vm._v(_vm._s(_vm.status[order.order_status]))])], 1)
    }), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 3
      }
    }, [_vm._v("收件人姓名：" + _vm._s(item.receiver_name))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("收件人手机号码：" + _vm._s(item.receiver_phone))]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 15
      }
    }, [_vm._v("地址：" + _vm._s(item.receiver_address))])], 1), _vm._v(" "), _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_vm._v("买家备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.remarks))])])], 1), _vm._v(" "), ((item.first_agency_id || item.second_agency_id) && !(item.profitsharing_info || item.profitsharing_fail_info)) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("该订单含有代理分账：")]), _vm._v(" "), _c('a-button', {
      on: {
        "click": function($event) {
          return _vm.profitsharingquery(item)
        }
      }
    }, [_vm._v("查询")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info || item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "start",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 20
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t分账状态提交记录：未提交\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 4
      }
    }, [_c('a-button', {
      attrs: {
        "type": "primary",
        "ghost": "",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.submitprofitsharing(item)
        }
      }
    }, [_vm._v("分账金额无误，提交分账")])], 1), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t一级代理分账信息：" + _vm._s(_vm.get_first_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t二级代理分账信息：" + _vm._s(_vm.get_second_info(item)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-col', {
      attrs: {
        "span": 4
      }
    }, [_c('a-button', {
      staticStyle: {
        "color": "red",
        "margin-top": "5px"
      },
      attrs: {
        "type": "danger",
        "ghost": "",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.modifyprofitsharing(item)
        }
      }
    }, [_vm._v("分账金额有误，修改提交")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_fail_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v(_vm._s(item.profitsharing_fail_info))])])], 1) : _vm._e(), _vm._v(" "), (item.profitsharing_info) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t实际分账信息：" + _vm._s(item.profitsharing_info.status) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((item.profitsharing_info.receivers), function(receivers, receiversindex) {
      return _c('a-col', {
        key: receiversindex,
        attrs: {
          "span": 8
        }
      }, [(receivers.type == 'MERCHANT_ID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(receivers.description) + ",金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (receivers.type == 'PERSONAL_OPENID') ? _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t账户:" + _vm._s(receivers.user_id) + ",实际分账金额￥:" + _vm._s(receivers.amount / 100) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
    })], 2) : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])])], 1)], 1)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "修改分账信息",
      "visible": _vm.modify_visible,
      "confirmLoading": _vm.modifyLoading
    },
    on: {
      "ok": _vm.modify_Ok,
      "cancel": _vm.modify_Cancel
    }
  }, [_c('div', {}, [(_vm.modify_info.first_agency_id) ? _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("一级分账金额")]), _vm._v(" "), _c('a-input-number', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "formatter": function (value) { return ("￥ " + value).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    },
    model: {
      value: (_vm.modify_info.first_agency_rebate),
      callback: function($$v) {
        _vm.$set(_vm.modify_info, "first_agency_rebate", $$v)
      },
      expression: "modify_info.first_agency_rebate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.modify_info.second_agency_id) ? _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_vm._v("二级分账金额")]), _vm._v(" "), _c('a-input-number', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "formatter": function (value) { return ("￥ " + value).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    },
    model: {
      value: (_vm.modify_info.second_agency_rebate),
      callback: function($$v) {
        _vm.$set(_vm.modify_info, "second_agency_rebate", $$v)
      },
      expression: "modify_info.second_agency_rebate"
    }
  })], 1) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38a69a56","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/ordermanagement/transactionreconciliation/index.vue
// module id = 2375
// module chunks = 1